import {Component, OnInit, ViewContainerRef} from '@angular/core';
import {AppService} from '../../../../appService';
import {LocalStorageService, SessionStorageService} from 'ngx-webstorage';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {MatDialog} from '@angular/material';
import {HttpClient, HttpParams} from '@angular/common/http';
import {ToastsManager} from 'ng2-toastr';
import {environment} from '../../../../../environments/environment';
import {ScsfmInstructionDialogComponent} from './scsfm-instruction-dialog/scsfm-instruction-dialog.component';

@Component({
  selector: 'app-student-counselling-show-from-mentor',
  templateUrl: './student-counselling-show-from-mentor.component.html',
  styleUrls: ['./student-counselling-show-from-mentor.component.css']
})
export class StudentCounsellingShowFromMentorComponent implements OnInit {
  selectedSemesterForSearch: any = '';
  studentId: any = '';
  teacherIdNameFilter: any = '';

  semesterList: any = [];
  studentCounsellingList: any = [];


  constructor(private appService: AppService,
              private localStorage: LocalStorageService,
              private sessionStorage: SessionStorageService,
              private route: ActivatedRoute,
              public dialog: MatDialog,
              private router: Router, private httpClient: HttpClient, public toastr: ToastsManager, vcr: ViewContainerRef) {
    this.toastr.setRootViewContainerRef(vcr); }


  ngOnInit() {
    this.route.params.subscribe( (params: Params) => { this.studentId = params['studentId'];  }   );
    this.appService.hasAccessToken();
    this.getSemesterList();
  }

  getSemesterList() {
    const myParams = new HttpParams();
    this.httpClient.get(environment.apiUrl + 'studentCounselling/semesterList', {
      headers: this.appService.getHeadersWithAccessToken(),
      params: myParams
    }).subscribe(res => {
        // console.log(res);
        this.semesterList = res;
      },
      msg => {
        console.error('error');
      }
    );
  }


  getStudentCounsellingList() {
    const myParams = new HttpParams().append('semesterId', this.selectedSemesterForSearch).append('studentId', this.studentId);
    this.httpClient.get(environment.apiUrl + 'teacherAccess/studentCounsellingViewForMentor/studentCounsellingList', { headers: this.appService.getHeadersWithAccessToken(), params: myParams })
      .subscribe(
        res => {
          // console.log('res' , res);
          this.studentCounsellingList = res;
        },
        msg => {
          console.error(`Error: ${msg.status} ${msg.statusText}`);
        }
      );
  }



  openScsfmInstructionDialog(): void {
    const dialogRef = this.dialog.open(ScsfmInstructionDialogComponent, {
      width: '60%',
      height: 'auto',
      disableClose: false,
      data: {}
    });
    dialogRef.afterClosed().subscribe(result => {
      // console.log('The dialog was closed');
    });
  }


}
